import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProBeforeMeetingContent のスタイル
 */
export const hotlineProBeforeMeetingContentStyle = tv({
    defaultVariants: {
        lastSection: false,
    },
    slots: {
        base: [],
        buttonGroup: ['flex-col sm:flex-row-reverse', 'mx-auto'],
        copyButton: ['group', 'flex items-center gap-x-4'],
        copyButtonText: [
            linkTextStyle({ isBold: true, isGroup: true, size: 'xs' }),
        ],
        interviewDate: [
            'flex flex-col items-center gap-y-16',
            'w-full',
            'p-16',
            'rounded-md',
            'bg-white',
        ],
        interviewDateText: [
            textStyle({ color: 'base', size: 'sm' }),
            'flex flex-row flex-wrap',
        ],
        interviewDateTextStrong: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
        ],
        interviewDateWrap: ['flex', 'items-center', 'gap-x-8'],
        interviewStartButton: ['max-w-full'],
        interviewStartContent: [
            'flex flex-col items-center gap-16',
            'w-full',
            'p-16',
            'mt-16',
            'rounded-md',
            'bg-blue-gray-75',
        ],
        interviewStartDescription: [textStyle({ color: 'error', size: 'xs' })],
        list: ['pl-20', textStyle({ color: 'base', size: 'sm' })],
        listItem: ['list-disc'],
        operationCheck: ['flex flex-col items-center gap-y-8', 'mt-24'],
        operationCheckText: [textStyle({ color: 'base', size: 'sm' })],
        section: [
            'flex flex-col gap-y-24',
            'border-t border-b-0 border-x-0 border-solid border-gray-300',
        ],
        sectionTitle: [headStyle({ color: 'base', isBold: true, size: 'xs' })],
        topContent: ['pb-24'],
    },
    variants: {
        /** 最後のセクションか */
        lastSection: {
            false: {
                section: ['py-24'],
            },
            true: {
                section: ['pt-24'],
            },
        },
    },
});
